<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-add-member`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 13c0-3.314 2.69-6 6-6s6 2.686 6 6-2.69 6-6 6-6-2.686-6-6zm6-10c-5.52 0-10 4.477-10 10s4.48 10 10 10 10-4.477 10-10S26.52 3 21 3zM8.25 36c.89-3.45 4.02-6 7.75-6h8.05a1 1 0 001-1v-2a1 1 0 00-1-1H16C9.37 26 4 31.373 4 38v4c0 1.105.9 2 2 2h18.05a1 1 0 001-1v-2a1 1 0 00-1-1H8v-2c0-.691.09-1.361.25-2zM37 28h-2a1 1 0 00-1 1v5h-5a1 1 0 00-1 1v2a1 1 0 001 1h5v5a1 1 0 001 1h2a1 1 0 001-1v-5h5a1 1 0 001-1v-2a1 1 0 00-1-1h-5v-5a1 1 0 00-1-1z"/></svg>
</template>
<script>

export default {
  name: 'IconAddMember',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
